<template>
  <div class="grid grid-cols-2 gap-5 mt-5" v-if="loading">
    <SkeletonLoader />
    <SkeletonLoader />
  </div>
  <div v-else>
    <div v-if="companiesDetails">
      <div class="grid grid-cols-2 gap-5 mt-5 mb-5">
        <a
          :href="
            $router.resolve({
              name: 'CompanyView',
              params: {
                id: company.id,
                slug: company.name ? $sanitizeTitle(company.name) : '',
              },
            }).href
          "
          v-for="company in companiesDetails.data"
          :key="company.id"
          class="flex flex-col border rounded-lg md:flex-row border-stone-200"
        >
          <div
            class="flex flex-col w-full md:border-r md:flex-row md:items-start md:justify-start md:w-5/12"
          >
            <img
              v-if="company.photo"
              :src="company.photo ? company.photo : `img/company.jpg`"
              class="h-[220px] w-full object-cover rounded-t-lg md:rounded-none md:rounded-l-lg"
              alt=""
            />
            <div
              v-else
              class="flex items-center justify-center h-[220px] w-[220px] font-bold text-7xl"
            >
              {{ $getInitials(company.name) }}
            </div>
          </div>
          <div class="relative flex md:w-7/12 md:justify-between">
            <div class="p-2 space-y-2">
              <h1 class="text-xl font-semibold">{{ company.name }}</h1>
              <p class="text-sm text-stone-500">Head office location: Ghana</p>
              <p class="text-sm text-gray-500">
                Agents: {{ company.number_of_agents }}
              </p>
              <div class="flex justify-between w-full pt-5 space-x-2">
                <div
                  class="md:w-[6rem] w-full flex justify-center items-center h-6 rounded bg-[#F7F6FB] text-primary p-1"
                >
                  <p class="text-xs font-semibold md:text-sm">
                    For Sale: {{ company.properties_for_sale_count }}
                  </p>
                </div>
                <div
                  class="md:w-[6rem] w-full flex justify-center items-center h-6 rounded bg-[#F7F6FB] text-primary p-1"
                >
                  <p class="text-xs font-semibold md:text-sm">
                    For Rent: {{ company.properties_for_rent_count }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>

      <div
        class="flex items-center justify-center mt-8 mb-8"
        v-if="companiesDetails.data.length >= 20"
      >
        <button
          class="w-20 h-12 p-1 font-semibold text-white bg-secondary rounded-xl"
        >
          View All
        </button>
      </div>

      <div
        v-else-if="companiesDetails.data.length <= 0"
        class="md:w-[825px] mt-10 flex justify-center items-center"
      >
        <p class="text-xl text-stone-500">No companies</p>
      </div>
    </div>
  </div>
</template>
<script>
import SkeletonLoader from "@/components/SkeletonLoader.vue";
export default {
  components: {
    SkeletonLoader,
  },
  props: {
    companiesDetails: Object,
  },
  data() {
    return {
      loading: true,
    };
  },
  watch: {
    companiesDetails: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.data.length >= 0) {
          // Wait for 1 second before setting loading to false
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        }
      },
    },
  },
};
</script>
